class SecureFileUploaderValidateErrorController {
  constructor(secureFileUploaderService) {
    this.name = 'secureFileUploaderValidateError';
    this.secureFileUploaderService = secureFileUploaderService;
    this.batchRow = {
      id: this.uploadState.batchId
    };
  }

  cancel() {
    this.secureFileUploaderService.cancel();
  }
}

SecureFileUploaderValidateErrorController.$inject = ['secureFileUploaderService'];

export default SecureFileUploaderValidateErrorController;



// WEBPACK FOOTER //
// ./app/components/secureFileUploaderValidateError/secureFileUploaderValidateError.controller.js